import api from '../services/api/axios';

export const Upload = (file: File, onUploadProgress?: (progress: number) => void) => {
  const controller = new AbortController();
  const promise = new Promise<string>((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    api
      .post(
        'file/',
        { file },
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = progressEvent.total
              ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
              : 0;
            onUploadProgress?.(percentCompleted);
          },
          signal: controller.signal,
        },
      )
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
  return [promise, () => controller.abort.bind(controller)] as [Promise<string>, () => void];
};

export const Delete = (id: string) => {
  return api.delete(`file/`, { params: { id } });
};
export const Download = (id: string) => {
  return new Promise<Blob>((resolve, reject) => {
    api
      .get(`file/`, { params: { id }, responseType: 'blob' })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
